import { render, staticRenderFns } from "./ReSubmitApp.vue?vue&type=template&id=77e07471&scoped=true"
import script from "./ReSubmitApp.vue?vue&type=script&lang=js"
export * from "./ReSubmitApp.vue?vue&type=script&lang=js"
import style0 from "./ReSubmitApp.vue?vue&type=style&index=0&id=77e07471&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e07471",
  null
  
)

export default component.exports